import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { loginCustomer } from '../../redux/slices/customerAuthSlice';
import { verifyAccessToken, loginAsUserFunc} from '../../redux/slices/protectSlice';
import bgSignin from '../../images/bg-signin.jpg';
import logo from '../../images/logo-agc.png';
import eyeIcon from '../../images/eye.svg';

const CustomerLoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status } = useSelector((state) => state.adminAuth);

  const { isAuthenticated, userType } = useSelector((state) => state.protect);
   useEffect(() => {
    if (isAuthenticated == null || isAuthenticated == 'null') {
      dispatch(verifyAccessToken());
    }
    if (isAuthenticated && userType == 'admin') {
       

      var shouldHideDashboard = localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1";
      if (!shouldHideDashboard) {
        navigate('/admin/users');
      } else {
        navigate('/admin/dashboard');
      }

    }
    if (isAuthenticated && userType == 'client') {
      navigate('/meal-plan'); 
    }
  }, [isAuthenticated]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(null);
    if (status !== 'loading') {
      const response = await dispatch(loginCustomer(formData));        
      if (response.payload && response.payload.status === 'Success') {
        dispatch(loginAsUserFunc());
      } else if (response.payload && response.payload.status === 'Error') {
        setErrorMessage(response.payload.message);
      } else {
        setErrorMessage('Unexpected error occurred. Please try again.');
      }
    }
  };

  if (isAuthenticated == 'null' || isAuthenticated == null) { return false; } 

  return (
    <div className="dashboard-container" id="app-body">
      <div className="bg-signin page-signin" style={{ backgroundImage: `url(${bgSignin})` }}>
        <div className="main-body justify-between">
          <div className="form-body">
            <div className="form-body-container">
              <section id="form" className="form">
                <form method="POST" id="signForm" onSubmit={handleSubmit}>
                  <div className="logo-signin">
                    <img src={logo} alt="logo" />
                  </div>
                  
                  <div className="form-sigin-wrap">
                    <h3>Welcome back to<br />Alex Gamble Coaching</h3>
                    <p>Your go-to diet app for achieving your health and wellness goals.</p>
                    
                    {errorMessage && (
                      <div className="alert alert-danger">
                        {errorMessage}
                      </div>
                    )}

                    <div className="form-group flex flex-col align-start">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group flex flex-col align-start">
                      <div className="password-wrap">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          id="password"
                          name="password"
                          required
                          placeholder="Password"
                          minLength="6"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <img
                          src={eyeIcon}
                          className="eye"
                          alt="toggle password visibility"
                          style={{ cursor: 'pointer' }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <button type="submit" className="btn">Login</button>
                    </div>
                    <div className="form-group flex justify-end forgotPassword">
                      <Link className="forgot" to="/forgot-password">Forgot Password?</Link>
                    </div>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
        <div className="text-center">
          <p className="text-muted">© 2024 AlexGambleCoaching. Crafted with <i className="mdi mdi-heart text-primary"></i></p>
        </div>
      </div>
    </div>
  );
};

export default CustomerLoginPage;